import React from "react";
import SectorCRUDTable from "@/components/SectorCRUDTable";
import { Thermometer } from "lucide-react";

const TYPE_LABELS = { temperature: "Température", cleaning: "Nettoyage", product: "Traçabilité produit" };

export default function ChefHACCP() {
  return (
    <SectorCRUDTable
      endpoint="/chef/secteur/haccp"
      eyebrow="Restauration · HACCP"
      title="Contrôles sanitaires"
      sub="Relevés de températures, plans de nettoyage et traçabilité produits."
      testidPrefix="haccp"
      defaultRow={() => ({ type: "temperature", zone: "", valeur: "", responsable: "", notes: "" })}
      columns={[
        { key: "type", label: "Type", width: "160px", render: (v) => <span className="font-semibold text-[#002FA7]">{TYPE_LABELS[v] || v}</span> },
        { key: "zone", label: "Zone" },
        { key: "valeur", label: "Valeur / Note", width: "160px", render: (v) => <span className="font-mono font-bold">{v || "—"}</span> },
        { key: "responsable", label: "Responsable", width: "180px" },
        { key: "created_at", label: "Date", width: "180px", render: (v) => v ? new Date(v).toLocaleString("fr-FR") : "—" },
      ]}
      fields={[
        { key: "type", label: "Type de contrôle", type: "select", span: 6, required: true, options: [
          { value: "temperature", label: "Température" },
          { value: "cleaning", label: "Nettoyage" },
          { value: "product", label: "Traçabilité produit" },
        ]},
        { key: "zone", label: "Zone / Équipement", span: 6, required: true, placeholder: "Frigo cuisine, Chambre froide…" },
        { key: "valeur", label: "Valeur / Référence", span: 6, placeholder: "3.5°C, Lot AB123…" },
        { key: "responsable", label: "Responsable", span: 6, required: true },
        { key: "notes", label: "Notes", type: "textarea", span: 12 },
      ]}
      emptyIcon={Thermometer}
      emptyText="Aucun relevé HACCP. Cliquez sur Ajouter pour enregistrer un contrôle."
    />
  );
}
